import Service from './service'
export var SettingsMessageType;
(function (SettingsMessageType) {
  SettingsMessageType["SETTINGS_UPDATE"] = "SETTINGS_UPDATE"
})(SettingsMessageType || (SettingsMessageType = {}))
export var ApiSettingsMessageType;
(function (ApiSettingsMessageType) {
  ApiSettingsMessageType["SETTINGS_UPDATE"] = "system.settings.update"
  ApiSettingsMessageType["SETTINGS_GET"] = "system.settings.get"
  ApiSettingsMessageType["SETTINGS_LOAD"] = "system.settings.load"
  ApiSettingsMessageType["SYSTEM_SOUND_PROPERTIES"] = "system.sound.properties"
  ApiSettingsMessageType["SYSTEM_SOUND_LOAD"] = "system.sound.load"
  ApiSettingsMessageType["SYSTEM_LANGUAGE_SET"] = "system.language.set"
})(ApiSettingsMessageType || (ApiSettingsMessageType = {}))
export var SettingsType;
(function (SettingsType) {
  /** Параметр плагина (см. Лингвобаза)  */
  SettingsType["APPLICATION"] = "application"
  /** Общий параметр (см. Лингвобаза)  */
  SettingsType["SYSTEM"] = "system"
})(SettingsType || (SettingsType = {}))
/**
 * Сервис для работы с настройками
 * @version 0.0.1
 * @since 1.9.1
 */
export default class SettingsService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiSettingsMessageType.SETTINGS_UPDATE:
          this.broadcast(SettingsMessageType.SETTINGS_UPDATE)
          break
        case ApiSettingsMessageType.SETTINGS_LOAD:
          const settings = {}
          for (const i of Object.keys(message.settings)) {
            const type = message.settings[i].settings_type
            const group = message.settings[i].group
            if (!settings.hasOwnProperty(type)) {
              settings[type] = {}
            }
            if (!settings[type].hasOwnProperty(group)) {
              settings[type][group] = {}
            }
            if (message.settings[i].name) {
              const name = message.settings[i].name.replace(/^\s+|\s+$/gm, '')
              settings[type][group][name] = message.settings[i].value
            }
          }
          this.resolve(this.waiters.settings, settings)
          break
        case ApiSettingsMessageType.SYSTEM_SOUND_LOAD:
          if (typeof message.sound.volume !== 'undefined') {
            this.resolve(this.waiters.volume, message.sound.volume)
          }
          else if (typeof message.sound.mic !== 'undefined') {
            this.resolve(this.waiters.volumeMic, message.sound.mic)
          }
          break
      }
    }
    this.waiters = {
      settings: [],
      volume: [],
      volumeMic: [],
    }
    this.messageChannel.subscribe(ApiSettingsMessageType.SETTINGS_UPDATE, messageHandler)
    this.messageChannel.subscribe(ApiSettingsMessageType.SETTINGS_LOAD, messageHandler)
    this.messageChannel.subscribe(ApiSettingsMessageType.SYSTEM_SOUND_LOAD, messageHandler)
  }
  /**
     * Сервис сообщил о наличии изменений в настройках
     * @since 1.8.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof SettingsService
     *
     * @example <caption>Сервис сообщил о наличии изменений в настройках</caption>
     * robot.settingsService.onChange(() => {
     *   // можно повторно запросить настройки
     * })
     */
  onChange(callback) {
    return this.subscribe(SettingsMessageType.SETTINGS_UPDATE, callback)
  }
  /**
     * Установить язык систем робота
     * @since 1.8.0
     * @param {string} language - язык в форме "language_country", где language - строчное двухбуквенное представление
     * языкового кода в формате ISO-639, и country - Заглавное, двух- или трёх-буквенное представление кода страны в формате ISO-3166
     * Например: en_US, ru_RU
     * WARNING: переключение языка приостанавливает работу всего приложения примерно на секунду
     * @memberof SettingsService
     *
     * @example <caption>Установить язык систем робота</caption>
     * robot.settingsService.setLanguage(language)
     */
  setLanguage(language) {
    this.messageChannel.send({
      type: ApiSettingsMessageType.SYSTEM_LANGUAGE_SET,
      language,
    })
  }
  /**
     * Получить уровень громкости звука
     * @since 1.8.0
     * @return {*}  {Promise<number>}
     * При успехе возвращает значение громкости звука
     * @memberof SettingsService
     *
     * @example <caption>Получить уровень громкости звука</caption>
     * robot.settingsService.getVolume().then((vol) => {
     *   console.log('Volume is', vol)
     * })
     */
  getVolume() {
    return this.execute({
      type: ApiSettingsMessageType.SYSTEM_SOUND_PROPERTIES,
      get_volume: '',
    }, this.waiters.volume)
  }
  /**
     * Установить уровень громкости звука
     * @since 1.8.0
     * @param {number} volume - значение громкости (0-100)
     * @memberof SettingsService
     *
     * @example <caption>Установить уровень громкости звука</caption>
     * robot.settingsService.setVolume(volume)
     */
  setVolume(volume) {
    this.messageChannel.send({
      type: ApiSettingsMessageType.SYSTEM_SOUND_PROPERTIES,
      set_volume: volume,
    })
  }
  /**
     * Получить уровень чувствительности микрофона
     * @since 1.8.0
     * @return {*}  {Promise<number>}
     * При успехе возвращает значение чувствительности микрофона
     * @memberof SettingsService
     *
     * @example <caption>Получить уровень чувствительности микрофона</caption>
     * robot.settingsService.getVolumeMic().then((vol) => {
     *   console.log('VolumeMic is', vol)
     * })
     */
  getVolumeMic() {
    return this.execute({
      type: ApiSettingsMessageType.SYSTEM_SOUND_PROPERTIES,
      get_mic: '',
    }, this.waiters.volumeMic)
  }
  /**
     * Установить уровень чувствительности микрофона
     * @since 1.8.0
     * @param {number} volume - значение чувствительности (0-100)
     * @memberof SettingsService
     *
     * @example <caption>Установить уровень чувствительности микрофона</caption>
     * robot.settingsService.setVolumeMic(volume)
     */
  setVolumeMic(volume) {
    this.messageChannel.send({
      type: ApiSettingsMessageType.SYSTEM_SOUND_PROPERTIES,
      set_mic: volume,
    })
  }
  /**
     * Получить настройки
     * @since 1.8.0
     * При успехе возвращает объект с настройками
     * @param {SettingRequest} options параметры запроса настройки
     * @return {*}  {Promise<Object>}
     * @memberof SettingsService
     *
     * @example <caption>Получить настройки</caption>
     * robot.settingsService.get({ settings_type: 'application',
     * group: 'foo',
     * name: 'bar'
     * }).then((data) => {
     *   console.log('setting is', data.application.foo.bar)
     * })
     */
  get(options) {
    return this.execute(Object.assign({
      type: ApiSettingsMessageType.SETTINGS_GET,
    }, options), this.waiters.settings)
  }
}
